module.exports = __webpack_public_path__ + "static/img/industries1.59f34a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries1.jpg
// module id = ABvX
// module chunks = 1